import {
  inject, provide, reactive, getCurrentInstance, computed,
} from 'vue';

import { verifyRouteResponse } from '@/router/verifyRoute';

const PROVIDE_UNIQUE_NAME = 'USE_RIGHTS_THEME';

type UseRightsProperties = { right?: verifyRouteResponse };

export const useRightsProvider = (): void => {
  provide(PROVIDE_UNIQUE_NAME, reactive<UseRightsProperties>({}));
};

const useRights = () => {
  const vm = getCurrentInstance()?.proxy;

  if (!vm) {
    throw new Error(
      'vue-query hooks can only be used inside setup() function.',
    );
  }
  const config = inject<UseRightsProperties>(PROVIDE_UNIQUE_NAME);
  if (!config) {
    throw new Error(
      "No apiClient found in Vue context, use 'useRightsProvider' to set one in the root component.",
    );
  }

  const setRight = (right: verifyRouteResponse) => {
    config.right = right;
  };

  const isForbidden = computed(() => config.right === verifyRouteResponse.forbidden);

  return {
    right: computed(() => config.right),
    isForbidden,
    setRight,
  };
};

export default useRights;
